const state = {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) ?? {},
    menuList: JSON.parse(localStorage.getItem('menuList')) ?? [],
    refreshFlag: 0
}

const mutations = {
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo || {}
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_MENU_LIST: (state, menuList) => {
        state.menuList = menuList
        localStorage.setItem('menuList', JSON.stringify(menuList))
        state.refreshFlag += 1
    },
    SET_LOGIN_STATUS: (state, status) => {
        console.log(status)
        state.isLoggedIn = status
        localStorage.setItem('isLoggedIn', status)
        state.refreshFlag += 1
    },
    REMOVE_LOGIN_STATUS() {
        localStorage.removeItem('isLoggedIn')
    },
    LOGOUT_ALL(state) {
        state.userInfo = {}
        state.menuList = []
        state.refreshFlag += 1
        localStorage.removeItem('userInfo')
        localStorage.removeItem('menuList')
        localStorage.removeItem('isLoggedIn')
    }
}

const actions = {}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}